import styled from 'styled-components';

export const Options = styled.div`
  margin-top: 16px;

  div {
    margin-top: 16px;
  }
`;
